import "./App.css";
import CssBaseline from "@mui/material/CssBaseline";
import Home from "./Home";
import React from "react";
import UserLogins from "./components/UserLogins";
import Users from "./components/Users";
import { Route, Routes, useLocation } from "react-router";
import { ThemeProvider } from "@mui/material/styles";
import { createAxiosClient } from "@ntg/component-library/utilities";
import { createThemeFromSeed } from "@ntg/component-library/theming";
import { useQuery } from "@tanstack/react-query";
import { LoginStateMachine } from "./LoginStateMachine.tsx";
import { LayoutContextProvider, UserContextProvider } from "@ntg/component-library/contexts";
import { DrawerContents } from "./DrawerContents.tsx";
import { DesktopLayout } from "@ntg/component-library/app";
import { AnimatePresence } from "motion/react";

export default function App() {
  const axiosAuth = createAxiosClient("Auth");
  const location = useLocation();
  const isLoginRoute = location.pathname === "/login";
  const shouldSkipValidation = isLoginRoute;

  const { isLoading, error } = useQuery({
    enabled: !shouldSkipValidation,
    queryFn: async () => {
      const response = await axiosAuth.get("/Auth/validate");
      return response.data;
    },
    queryKey: ["validate"],
  });

  if (isLoading) return "Authenticating...";

  if (error) return "An error has occurred: " + error.message;

  const isDarkMode = window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
  const theme = createThemeFromSeed({ menuBar: "rgb(54, 114, 79)", isDarkMode });

  return (
    <>
      {shouldSkipValidation && (
      <Routes>
        <Route element={<LoginStateMachine />} path="/login" />
      </Routes>
      )}
      {!shouldSkipValidation && (
        <ThemeProvider theme={theme}>
            <CssBaseline />
              <UserContextProvider>
              <LayoutContextProvider DrawerContents={DrawerContents} ModuleName={"USER MANAGEMENT"} ModuleTitle={"USER MANAGEMENT"}>
                <DesktopLayout
                  MainContent={
                    <AnimatePresence mode="wait">
                      <Routes>
                        <Route element={<Home />} path="/" />
                        <Route element={<Home />} path="/home" />
                        <Route element={<Users />} path="/users" />
                        <Route element={<UserLogins />} path="/userLogins" />
                      </Routes>
                    </AnimatePresence>
                  }
                  TerminalContent={<div />}
                />
              </LayoutContextProvider>
              </UserContextProvider>
        </ThemeProvider>
      )}
    </>
  );
}
